import type { Transaction, SplitRule, GrootboekRekening, BusinessRules, Relatie } from '@/types'
import { v4 as uuidv4 } from 'uuid'

export const DEFAULT_BUSINESS_RULES: BusinessRules = {
  debiteurenRekening: 3,
  bankRekening: 1,
  reserveRekeningen: [2, 8],
  kostenRekeningen: [6, 7],
  arrearsThreshold: 23300,
  lockedUntil: null,
}

export const DEFAULT_ACCOUNTS: GrootboekRekening[] = [
  { code: 1, naam: 'Rekening ABN' },
  { code: 2, naam: 'Algemene reserve' },
  { code: 3, naam: 'Debiteuren' },
  { code: 4, naam: 'Crediteuren' },
  { code: 5, naam: 'Kruisposten' },
  { code: 6, naam: 'Maandelijkse lasten' },
  { code: 7, naam: 'Jaarlijkse lasten' },
  { code: 8, naam: 'Reserve onvoorzien en groot onderhoud' },
]

const relatieIds = {
  vve: uuidv4(),
  lid1: uuidv4(),
  lid2: uuidv4(),
  lid3: uuidv4(),
  vendorA: uuidv4(),
}

export const DEFAULT_RELATIES: Relatie[] = [
  { id: relatieIds.vve, naam: 'Huishouden', type: 'Vendor' },
  { id: relatieIds.lid1, naam: 'Johannes', type: 'Member' },
  { id: relatieIds.lid2, naam: 'Annet', type: 'Member' },
  { id: relatieIds.lid3, naam: 'Pieter', type: 'Member' },
]

export const DEMO_RELATIES: Relatie[] = [
  ...DEFAULT_RELATIES,
  { id: relatieIds.vendorA, naam: 'Schoonmaakbedrijf De Wit', type: 'Vendor' },
]

export const DEMO_SPLIT_RULES: SplitRule[] = [
  {
    id: uuidv4(),
    description: 'Maandelijkse bijdrage',
    totalAmount: 23300,
    allocations: [
      { grootboekrekening: 6, amount: 15000 },
      { grootboekrekening: 7, amount: 4000 },
      { grootboekrekening: 2, amount: 2500 },
      { grootboekrekening: 8, amount: 1800 }
    ]
  }
]

const now = new Date().toISOString()

export const DEMO_TRANSACTIONS: Transaction[] = [
  // Opening balance
  {
    id: uuidv4(),
    boekstuknr: '2026001',
    datum: '2026-01-01',
    omschrijving: 'Beginbalans',
    createdAt: now,
    updatedAt: now,
    entries: [
      { id: uuidv4(), relatieId: relatieIds.vve, grootboekrekening: 1, debet: 450050, credit: 0 },
      { id: uuidv4(), relatieId: relatieIds.vve, grootboekrekening: 2, debet: 0, credit: 300000 },
      { id: uuidv4(), relatieId: relatieIds.vve, grootboekrekening: 8, debet: 0, credit: 150050 },
    ]
  },
  // January Contributions Johannes
  {
    id: uuidv4(),
    boekstuknr: '2026002',
    datum: '2026-01-10',
    omschrijving: 'Bijdrage Johannes jan 2026',
    createdAt: now,
    updatedAt: now,
    entries: [
      { id: uuidv4(), relatieId: relatieIds.lid1, grootboekrekening: 3, debet: 23300, credit: 0 },
      { id: uuidv4(), relatieId: relatieIds.lid1, grootboekrekening: 6, debet: 0, credit: 15000 },
      { id: uuidv4(), relatieId: relatieIds.lid1, grootboekrekening: 7, debet: 0, credit: 4000 },
      { id: uuidv4(), relatieId: relatieIds.lid1, grootboekrekening: 2, debet: 0, credit: 2500 },
      { id: uuidv4(), relatieId: relatieIds.lid1, grootboekrekening: 8, debet: 0, credit: 1800 },
    ]
  },
  // Bank payment Johannes
  {
    id: uuidv4(),
    boekstuknr: '2026003',
    datum: '2026-01-12',
    omschrijving: 'Betaling bijdrage jan - Johannes',
    createdAt: now,
    updatedAt: now,
    entries: [
      { id: uuidv4(), relatieId: relatieIds.lid1, grootboekrekening: 1, debet: 23300, credit: 0 },
      { id: uuidv4(), relatieId: relatieIds.lid1, grootboekrekening: 3, debet: 0, credit: 23300 },
    ]
  },
  // Annet contribution (unpaid, partially split for demo)
  {
    id: uuidv4(),
    boekstuknr: '2026004',
    datum: '2026-01-10',
    omschrijving: 'Bijdrage Annet jan 2026',
    createdAt: now,
    updatedAt: now,
    entries: [
      { id: uuidv4(), relatieId: relatieIds.lid2, grootboekrekening: 3, debet: 15000, credit: 0 },
      { id: uuidv4(), relatieId: relatieIds.lid2, grootboekrekening: 6, debet: 0, credit: 15000 },
    ]
  },
  // Expense
  {
    id: uuidv4(),
    boekstuknr: '2026005',
    datum: '2026-01-20',
    omschrijving: 'Schoonmaakkosten',
    createdAt: now,
    updatedAt: now,
    entries: [
      { id: uuidv4(), relatieId: relatieIds.vendorA, grootboekrekening: 6, debet: 5450, credit: 0 },
      { id: uuidv4(), relatieId: relatieIds.vendorA, grootboekrekening: 1, debet: 0, credit: 5450 },
    ]
  }
]
